import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Switch = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="switch icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M6.13993 11.0004C6.51547 11.0005 6.87601 11.1445 7.15067 11.4076C7.44524 11.6907 7.61138 12.0753 7.61453 12.4896C7.61926 12.9034 7.46142 13.29 7.17313 13.5805L5.08817 15.8305H13.4417C14.3022 15.8305 15.0003 16.5426 15.0003 17.4203C15 18.2975 14.302 19.0082 13.4417 19.0082H5.12332L7.15946 21.2729C7.45123 21.5582 7.61296 21.9444 7.61453 22.3578C7.61604 22.7713 7.45557 23.1569 7.16434 23.4437L7.02567 23.5805C6.75288 23.85 6.38766 24.0003 6.00418 24.0004C5.60326 24.0004 5.22693 23.8387 4.94461 23.5453L0.34598 18.3168C-0.117027 17.8333 -0.114592 17.0491 0.349886 16.5687L5.08817 11.4477C5.36733 11.1591 5.74216 11.0004 6.13993 11.0004ZM18.0462 0.000389099C18.4479 0.000389099 18.8247 0.161279 19.1077 0.454491L23.7181 5.68301C24.1822 6.16649 24.1797 6.95069 23.7141 7.43105L18.9641 12.5521C18.6843 12.8407 18.3092 13.0004 17.9104 13.0004C17.534 13.0004 17.1731 12.8552 16.8977 12.5922C16.6024 12.3091 16.4351 11.9245 16.4319 11.5102C16.4272 11.0965 16.5853 10.7098 16.8743 10.4193L18.9641 8.16933H10.6263C9.76391 8.16915 9.0649 7.45789 9.06473 6.58047C9.06473 5.70322 9.7638 4.99178 10.6263 4.9916H18.929L16.888 2.72695C16.5956 2.44159 16.4335 2.05536 16.4319 1.64199C16.4305 1.22851 16.5912 0.842913 16.8831 0.556053L17.0227 0.419334C17.2962 0.149805 17.6618 0.000447968 18.0462 0.000389099Z"
    />
  </svg>
)
